export default __webpack_public_path__ + "static/media/hibiny.a1052919.jpg";